import { printNativeMethodFallback } from './logger';

const copyWithSelection = (text: string): boolean => {
  const container = document.body ?? document.documentElement;
  const textArea = document.createElement('textarea');
  const activeElement = document.activeElement;

  textArea.value = text;
  textArea.readOnly = true;
  textArea.setAttribute('aria-hidden', 'true');
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  textArea.style.top = '0';
  textArea.style.opacity = '0';
  textArea.style.pointerEvents = 'none';

  container.appendChild(textArea);
  textArea.select();
  textArea.setSelectionRange(0, text.length);

  try {
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    textArea.remove();
    if (activeElement instanceof HTMLElement) {
      activeElement.focus();
    }
  }
};

const printCopyFailure = (): void => {
  printNativeMethodFallback('copyText', 'copyData', '浏览器剪贴板能力，但复制失败');
};

/**
 * 优先使用 Clipboard API，失败时降级为选区复制。
 */
export const copyTextInBrowser = (text: string): void => {
  const clipboard = navigator.clipboard;

  if (clipboard?.writeText) {
    try {
      void clipboard.writeText(text).catch(() => {
        if (!copyWithSelection(text)) {
          printCopyFailure();
        }
      });
      return;
    } catch {
      // 某些 WebView 暴露了 Clipboard API，但调用时会同步抛错，继续使用兼容方案。
    }
  }

  if (!copyWithSelection(text)) {
    printCopyFailure();
  }
};
